import { api } from 'utility';
import { getVoucherFullInfoUrl } from 'URLs';
export function getVourcher(id) {
  return api
    .get(getVoucherFullInfoUrl(id), { params: { size: 1, offset: 0 } })
    .then((res) => res.data);
}

export default {
  getVourcher,
};
